import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { merchantApi } from "@api";
import { ArrowLeftColor } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier, IMerchant, ISurvey } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { BoxSurvey } from "./shared/BoxSurvey";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
}

export const ComponentSurvey = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //page props
    const { avatar, fullName, memberTier } = props;
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    const { themes } = useSelector(selectMerchant);
    const [surveyList, setSurveyList] = useState<ISurvey[]>([]);
    const [isLoading, setIsloading] = useState(true);

    useEffect(() => {
        fetchSurvey();
    }, []);

    const fetchSurvey = async () => {
        let res = await merchantApi.getSurveyList();
        if (typeof res.data !== "string" && res.data.length > 0) {
            setSurveyList(res?.data);
            setIsloading(false);
        }
    };

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={isLoading}
                avatar
                active
                title={true}
                paragraph={{ rows: 1, width: [113] }}
            ></Skeleton>
            <Skeleton
                loading={isLoading}
                avatar
                active
                title={true}
                paragraph={{ rows: 1, width: [113] }}
            ></Skeleton>
            <Skeleton
                loading={isLoading}
                avatar
                active
                title={true}
                paragraph={{ rows: 1, width: [113] }}
            ></Skeleton>
            <Skeleton
                loading={isLoading}
                avatar
                active
                title={true}
                paragraph={{ rows: 1, width: [113] }}
            ></Skeleton>
        </StyledSkeleton>
    );

    return (
        <>
            <RenderMeta title={t("meta.survey_page")} />
            <StyledSurvey themeColor={themes?.themeColor!}>
                <header>
                    {/* <div className="back-arrow">
                        <ArrowLeft onClick={() => history.push(PATH_HOME)} />
                        <span>{t("page.back")}</span>
                    </div> */}
                    <div className="back-arrow">
                        <ArrowLeftColor
                            color={themes?.themeColor}
                            onClick={() => history.push(PATH_HOME)}
                        />
                        {/* <span>{t("page.back")}</span> */}
                    </div>
                    <div className="logo-product">
                        {/* <img src="../images/logo-pet.svg" alt="" /> */}
                    </div>
                    <div className="logo-survey">
                        {/* <img src="../images/logo-survey.svg" alt="" /> */}
                        Survey
                    </div>
                </header>

                {isLoading === false ? (
                    <>
                        <div className="layout-product-survey">
                            {surveyList?.length > 0 &&
                                surveyList?.map((sItem, sIndex) => {
                                    if (sItem?.turnOn) {
                                        return (
                                            <BoxSurvey
                                                image={sItem?.welcomeScreenImages[0] || ""}
                                                title={sItem?.surVeyName || ""}
                                                point={sItem?.pointGiven || "0"}
                                                id={sItem?._id}
                                                key={sIndex}
                                                isComplete={sItem?.completed}
                                                merchant={merchant as IMerchant}
                                            />
                                        );
                                    }
                                })}
                        </div>
                    </>
                ) : (
                    <>
                        {surveyList?.length === 0 && isLoading ? (
                            <div className="nodata">
                                <p>No data</p>
                            </div>
                        ) : (
                            loadingComponent
                        )}
                    </>
                )}
            </StyledSurvey>
        </>
    );
};

const StyledSkeleton = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 12px;
    .ant-skeleton {
        display: flex;
        width: 100%;
        flex-direction: column;
        .ant-skeleton-header {
            padding-right: 0;
            span {
                width: 100%;
                height: 167px;
                border-radius: 14px;
            }
        }
        .ant-skeleton-title {
            width: 100% !important;
            height: 10px;
            border-radius: 4px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0 !important;
            li {
                height: 10px;
                border-radius: 4px;
                &:last-child {
                    margin-top: 15px;
                }
            }
        }
    }
`;

const StyledSurvey = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    padding: 0 15px;
    height: 100vh;
    background-color: #fff;
    background-position: right top;
    background-repeat: no-repeat;
    .nodata {
        text-align: center;
        p {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            color: rgb(155, 155, 155);
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .layout-product-survey {
        display: grid;
        gap: 16px;
        grid-template-columns: 1fr 1fr;
        .ant-skeleton {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            background-color: #ddd;
            border-radius: 10px;
            padding: 12px;
            .ant-skeleton-avatar {
                width: 100px;
                height: 100px;
                margin-bottom: 12px;
                margin-top: 12px;
            }
            .ant-skeleton-header {
                padding-right: 0;
            }
            .ant-skeleton-paragraph {
                text-align: center;
                width: 100%;
                display: table;
                margin: 0 auto;
                margin-bottom: 12px;
                li {
                    margin: 0 auto;
                    margin-top: 5px;
                    border-radius: 16px;
                    height: 10px;
                }
            }
        }
        .box-product-survey {
            .img-product-survey {
                width: 100%;
                padding-top: 100%;
                position: relative;
                margin-bottom: 10px;
                border-radius: 16px;
                overflow: hidden;
                a {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
        .detail-product-survey {
            .title-product-survey {
                a {
                    color: #222;
                    font-size: 14px;
                    line-height: 18px;
                    margin-bottom: 5px;
                    font-weight: 600;
                }
            }
            .point-product-survey {
                color: #666666;
                font-size: 12px;
                line-height: 20px;
                span {
                    margin-right: 5px;
                }
            }
        }
    }
`;
